module.exports = __webpack_public_path__ + "img/khalid.c61272fa.jpeg";